module.exports = __webpack_public_path__ + "img/Inflammation-OPSCC_PMID37704757.4bf3ebc7.png";